// extracted by mini-css-extract-plugin
export default {"setUpForm":"AuthForm_setUpForm__Oc-I3","setUpHeader":"AuthForm_setUpHeader__1uoNe"};